import React from "react";
import { MessageSquare, FileText } from "lucide-react";

function JobDetail({ showCV, onToggleView, resumeEnabled, cvUrl, children }) {
  return (
    <div className="bg-card rounded-xl shadow-xl overflow-hidden">
      <div className="bg-muted p-6">
        <div className="flex items-center justify-between">
          <div>
            <h2 className="text-3xl font-bold text-primary-dark mb-2">
              {showCV && cvUrl ? "Candidate CV" : "Application Questions"}
            </h2>
            <p className="text-[#F4F4F5] text-lg">
              {showCV && cvUrl ? " " : " "}
            </p>
          </div>
          {resumeEnabled && cvUrl && (
            <button
              onClick={onToggleView}
              className="bg-primary-dark hover:bg-primary-dark text-white px-4 py-2 rounded-lg transition-colors duration-200 flex items-center gap-2"
            >
              {showCV ? (
                <>
                  <MessageSquare className="text-foreground w-5 h-5" />
                  View Questions
                </>
              ) : (
                <>
                  <FileText className="text-foreground w-5 h-5" />
                  View CV
                </>
              )}
            </button>
          )}
        </div>
      </div>
      {children}
    </div>
  );
}

export default JobDetail;
